import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
  Button,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import DialogActions from "@mui/material/DialogActions";
import AlertBar from "./AlertBar";
import { API_URL } from "../../config/environment";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const EditRole = ({
  open,
  rowId,
  onClose,
  onSuccess,
  onError,
  onStatusChange,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [role, setRole] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState(false);

  const token = sessionStorage.getItem("authToken");

  const roles = [
    { label: "Admin", value: "admin" },
    { label: "Editor", value: "editor" },
    { label: "User", value: "user" },
  ];

  const handleChange = (event) => {
    setRole(event.target.value);
  };

  function handleOnClose() {
    setRole(null);
    onClose();
  }

  async function handleUpdate() {
    await updateUser(rowId, { role: role });
    onStatusChange();
    handleOnClose();
  }

  async function updateUser(id, body) {
    console.log({ id });
    const url = `${API_URL}/users/${id}`;
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.status === 403) {
        return onError("You are not permitted to update user");
      }

      const data = await response.json();

      if (data.status === "success") {
        onSuccess("User updated successfully");
        navigate("/admin-dashboard");
      } else {
        return onError(data.message);
      }
    } catch (error) {
      return onError("An unexpected error occured");
    }
  }

  const dialogStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(5px)",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "16px", // Add margin as needed
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        style={dialogStyle}
        maxWidth="xl"
        fullWidth={true}
      >
        {/* Close button */}
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleOnClose}
          style={closeButtonStyle}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle>
          <Typography variant="h5" gutterBottom fontWeight={700}>
            Change User Role
          </Typography>
        </DialogTitle>
        <DialogContent>
          {/* Display current step */}

          <Typography variant="h6" gutterBottom fontWeight={300} fontSize={14}>
            Select the type of role for this user
          </Typography>

          <FormControl sx={{ m: 1, minWidth: 500 }}>
            <InputLabel id="export-data-label">Select Role</InputLabel>
            <Select
              labelId="export-data-lable"
              id="export-data-lable"
              value={role}
              required
              label="Select Role"
              placeholder="Select user role"
              onChange={handleChange}
              name="edit-role"
              error={errors}
              helperText={errors && "User role is required"}
            >
              {roles &&
                roles.map((role) => (
                  <MenuItem value={role.value}>{role.label}</MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            onClick={handleUpdate}
            disabled={role ? false : true}
            sx={{ margin: "20px" }}
          >
            Change
          </Button>
        </DialogActions>
      </Dialog>
      <AlertBar
        open={errors}
        message={errorMessage}
        severity={"error"}
        onClose={() => setErrors(false)}
      />
    </>
  );
};

export default EditRole;
